/**
 * The data policy a clinic accepts when its owner activates it.
 *
 * The text lives on the web app's public page at /policy (in English and
 * Arabic). This is its version: the date the wording last changed in a way
 * that matters. The API records the version the clinic accepted, and asks for
 * acceptance again when the version moves, so "the clinic agreed" always names
 * WHICH text it agreed to.
 *
 * Decided 2026-09-28: the first clinics are in Syria; the service is hosted in
 * the European Union; the clinic agrees to that at activation, on its own
 * behalf, before any patient record is stored.
 */
export const POLICY_VERSION = '2026-09-28';
